module.exports = __webpack_public_path__ + "img/bg-green.2eb4f928.png";